import React from 'react';
import Header from './Header';

/**
 * PageLayout - Standard page wrapper with consistent padding and structure
 * 
 * @param {React.ReactNode} children - Page content
 * @param {string} title - Page title
 * @param {string} subtitle - Page subtitle
 * @param {Array} breadcrumbs - Breadcrumb navigation [{label, path?}]
 * @param {React.ReactNode} actions - Header action buttons
 * @param {boolean} showSearch - Show search in header
 * @param {boolean} fullWidth - Remove max-width constraint
 * @param {boolean} noPadding - Remove content padding
 * @param {string} className - Additional classes for content area
 */
const PageLayout = ({
  children,
  title,
  subtitle,
  breadcrumbs = [],
  actions = null,
  showSearch = true,
  fullWidth = false,
  noPadding = false,
  className = '',
}) => {
  return (
    <div className="flex-1 flex flex-col min-h-screen bg-zinc-50">
      <Header
        title={title}
        subtitle={subtitle}
        breadcrumbs={breadcrumbs}
        actions={actions}
        showSearch={showSearch}
      />
      
      <main className={`
        flex-1
        ${noPadding ? '' : 'p-6 lg:p-8'}
        ${className}
      `}>
        <div className={fullWidth ? '' : 'max-w-[1600px] mx-auto'}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default PageLayout;

// Also export the individual components for flexibility
export { default as Header } from './Header';
export { default as Sidebar } from './Sidebar';

